import { getMarqueeLenders } from "@/lib/lenderSelection";
import { LenderLogo } from "./LenderLogo";

export function BankMarquee() {
  const lenders = getMarqueeLenders();
  return (
    <section className="border-y border-border bg-card/60 py-8">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <p className="mb-5 text-center text-sm font-semibold text-foreground/80">
          Hitta banken som passar din <span className="underline-brand font-bold">situation</span>
        </p>
        <div className="relative overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]">
          <div className="marquee-track flex w-max items-center gap-10">
            {[0, 1].map((k) => (
              <div key={k} className="flex items-center gap-10">
                {lenders.map((l) => (
                  <div
                    key={`${k}-${l.id}`}
                    className="flex h-16 w-40 shrink-0 items-center justify-center overflow-hidden rounded-lg bg-white px-5 py-3 shadow-sm sm:h-20 sm:w-48"
                    title={l.name}
                  >
                    {l.logoUrl ? (
                      <img
                        src={l.logoUrl}
                        alt={`${l.name} logotyp`}
                        className="max-h-full max-w-full object-contain"
                        draggable={false}
                        loading="lazy"
                      />
                    ) : (
                      <LenderLogo lender={l} size={48} bare />
                    )}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
